var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "theme-progress-container"
  }, _vm._l(_vm.totalUnits, function (item) {
    return _c('div', {
      key: item,
      staticClass: "divider",
      style: {
        background: item <= _vm.completedUnits ? _vm.themeProgressBackground : ''
      },
      attrs: {
        "aria-label": ((_vm.completedUnits) + " out of " + (_vm.totalUnits) + " completed")
      }
    });
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }